import React from "react";
import { Link } from "react-router-dom";
import { homePageV2EventsNow } from "../content/homePageV2Content";

export function EventsSectionV2() {
  const { cards, link } = homePageV2EventsNow;

  return (
    <section className="mh2v2-now mh2v2-section-light" id="events">
      <div className="mh2v2-container">
        <h3 className="mh2v2-section-title mh2v2-section-title--center mh2v2-teal-text">
          WHAT&apos;S HAPPENING NOW?
        </h3>
        <div className="mh2v2-now-grid">
          {/* TODO: live events feed */}
          {cards.map((card) => (
            <article className="mh2v2-now-card" key={card.title}>
              <img src={card.image} alt={card.title} />
              <div className="mh2v2-now-card__overlay">
                <h4>{card.title}</h4>
                <div className="mh2v2-now-card__footer">
                  <p>{card.text}</p>
                  <Link to={card.to} className="mh2v2-inline-btn">
                    Events →
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
        <Link className="mh2v2-link-row" to={link.to}>
          {link.label} →
        </Link>
      </div>
    </section>
  );
}

export default EventsSectionV2;
